import React from 'react'
import Page from '../Page'

export default ({children, title, subtitle, isNarrow = true, ...props}) => (
  <Page
    {...props}
    title={<h3 className='title'>{title}</h3>}
    subtitle={subtitle && <span>{subtitle}</span>}
    className={`has-background-light${isNarrow ? ' is-narrow' : ''}`}
    buttons={children}
  />
)
